import { Link } from 'react-router-dom';
import { BreadcrumbConfig } from '../types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

type BreadcrumbItemProps = {
  breadcrumb: BreadcrumbConfig;
  isActive: boolean;
};

export const BreadcrumbItem = ({ breadcrumb, isActive }: BreadcrumbItemProps) => {
  const { t } = useTranslation();

  const commonProps = {
    className: classNames(
      isActive ? 'text-gray-700' : 'text-gray-500 max-w-64',
      'text-sm font-medium truncate',
      !isActive && 'hover:text-gray-700',
    ),
  };

  const content = typeof breadcrumb.label === 'string' ? breadcrumb.label : breadcrumb.label(t);

  if (isActive) {
    return (
      <span aria-current="page" aria-disabled="true" {...commonProps}>
        {content}
      </span>
    );
  }

  return (
    <Link to={breadcrumb.to} state={{ keepBreadcrumbs: true }} {...commonProps}>
      {content}
    </Link>
  );
};
